import { createApi } from "../axiosInstance";
import { createPurchaseApi } from "../shared/purchaseApiFactory";

const api = createApi("myFPO");

export const {
  getPurchaseOrders,
  getPurchaseOrderByVendor,
  getPurchaseOrderById,
  createPurchaseOrder,
  updatePurchaseOrder,
  deletePurchaseOrder,
  downloadPurchaseOrderReport,
  getPurchaseInvoices,
  getPurchaseInvoiceByVendor,
  getPurchaseInvoiceById,
  createPurchaseInvoice,
  updatePurchaseInvoice,
  deletePurchaseInvoice,
  downloadPurchaseInvoiceReport,
  getPurchaseReturns,
  getPurchaseReturnByPurchase,
  getPurchaseReturnById,
  createPurchaseReturn,
  updatePurchaseReturn,
  deletePurchaseReturn,
  downloadPurchaseReturnReport,
  getPurchaseStock,
  getPurchaseReturnStock,
  getPurchaseOverallStock,
  downloadPurchaseOverallStockReport,
} = createPurchaseApi(api);
